'use client';

import { useEffect, useState } from 'react';

import { Loader2 } from 'lucide-react';

interface TextAttachmentViewProps {
	url: string;
	fileName: string;
}

export function TextAttachmentView({ url, fileName }: TextAttachmentViewProps) {
	const [text, setText] = useState<string | null>(null);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		let cancelled = false;
		setText(null);
		setError(null);

		fetch(url)
			.then(async (res) => {
				if (!res.ok) throw new Error(`Failed to load (${res.status})`);
				return res.text();
			})
			.then((body) => {
				if (!cancelled) setText(body);
			})
			.catch((err: unknown) => {
				if (!cancelled) {
					setError(err instanceof Error ? err.message : 'Failed to load file');
				}
			});

		return () => {
			cancelled = true;
		};
	}, [url]);

	return (
		<div
			className="flex h-[85vh] w-[80vw] flex-col rounded-lg bg-background"
			onClick={(e) => e.stopPropagation()}
		>
			{text === null && error === null && (
				<div className="flex flex-1 items-center justify-center text-neutral/50">
					<Loader2 className="size-5 animate-spin" />
				</div>
			)}
			{error !== null && (
				<div className="flex flex-1 items-center justify-center px-6 text-center text-[13px] text-neutral/60">
					Could not load {fileName}: {error}
				</div>
			)}
			{text !== null && (
				<pre className="flex-1 overflow-auto whitespace-pre-wrap break-words p-6 font-mono text-[13px] leading-relaxed text-neutral/90">
					{text}
				</pre>
			)}
		</div>
	);
}
